import updateService from '../../services/update-service';
import DialogComponent, { DialogProps } from '../widgets/dialog/DialogComponent';

export interface Props extends DialogProps {
  id: string;
  type: string;
}

export default class FirmwareRenameDialog extends DialogComponent<Props> {

  state = {
    type: this.props.type,
    updating: false
  }

  render() {
    return (
      <div className="ltr text-left">
        <input
          autoFocus
          type="text"
          value={this.state.type}
          className="form-control text-center"
          onChange={(event) => { this.setState({ type: event.target.value }) }}
        />
        <div className="col-lg-5 col-12 mx-auto">
          <button
            onClick={this.handleRenameClick}
            className="ant-btn ant-btn-primary w-100 mt-3 mx-auto"
            {...(this.state.updating ? { disabled: true } : {})}>تغییر نام</button>
        </div>
      </div>
    );
  }

  handleRenameClick = async () => {
    const { id } = this.props;
    this.setState({ updating: true });
    try {
      await updateService.update(id, { type: this.state.type });
      this.resolve(this.state.type);
      this.close();
    }
    catch (e) {
    }
  }
}
